import resolve from '../../../../../modules/api/resolve';
import { apiPost, generateFormData } from '../../../../../modules/apiHelper';

export default {
  async createProgramModule(context, data) {
    const response = await resolve(apiPost('add_prog_goal', generateFormData(data), 79)).then(async (res) => {
      if (!res) return false;

      return true;
    });

    return response;
  },

  async updateProgramModule(context, data) {
    const goalNameReq = resolve(apiPost(
      'edit_prog_goal_name',
      generateFormData({
        goalid: data.moduleId,
        goal_name: data.name,
      }),
      79,
    ));

    const goalDescReq = resolve(apiPost(
      'edit_prog_goal_desc',
      generateFormData({
        goalid: data.moduleId,
        desc: data.description,
      }),
      79,
    ));

    const goalDurReq = resolve(apiPost(
      'edit_prog_goal_duration',
      generateFormData({
        goalid: data.moduleId,
        duration: data.duration,
      }),
      79,
    ));

    const goalStartReq = resolve(apiPost(
      'edit_prog_goal_start',
      generateFormData({
        goalid: data.moduleId,
        start: data.start,
      }),
      79,
    ));

    const result = await Promise.all([
      goalNameReq,
      goalDescReq,
      goalDurReq,
      goalStartReq,
    ]);

    return result.every((v) => !!v);
  },

  async deactivateProgramModule(context, goalid) {
    const response = await resolve(apiPost('prog_dev_goal', generateFormData({ goalid }), 79)).then(async (res) => {
      if (!res) return false;

      return true;
    });

    return response;
  },

  async getProgramModules(context, data) {
    const response = await resolve(apiPost('prog_goal_list', generateFormData(data), 79)).then(async (res) => {
      if (!res) return false;

      return res.prog_goal_list || [];
    });

    return response;
  },

  async activateProgramModule(context, programId) {
    // todo
    // const formData = generateFormData({
    //   progid: programId,
    //   reason: '[module is in range]',
    // });

    // const response = await resolve(apiPost('act_prog', formData, 79)).then(async (res) => {
    //   if (!res) return false;

    //   return true;
    // });

    // return response;

    return true;
  },
};
